import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LockOpenIcon = function LockOpenIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.5002 17.5H5.50016C5.05814 17.5 4.63421 17.3244 4.32165 17.0118C4.00909 16.6993 3.8335 16.2754 3.8335 15.8333V10.8333C3.8335 10.3913 4.00909 9.96738 4.32165 9.65482C4.63421 9.34226 5.05814 9.16667 5.50016 9.16667H7.16683H15.5002C15.9422 9.16667 16.3661 9.34226 16.6787 9.65482C16.9912 9.96738 17.1668 10.3913 17.1668 10.8333V15.8333C17.1668 16.2754 16.9912 16.6993 16.6787 17.0118C16.3661 17.3244 15.9422 17.5 15.5002 17.5Z",
      fill: "#D0E124"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.16683 9.16667V5.83333C7.16683 4.94928 7.51802 4.10143 8.14314 3.47631C8.76826 2.85119 9.61611 2.5 10.5002 2.5C11.3842 2.5 12.2321 2.85119 12.8572 3.47631C13.4823 4.10143 13.8335 4.94928 13.8335 5.83333M10.5002 12.5V14.1667M5.50016 17.5H15.5002C15.9422 17.5 16.3661 17.3244 16.6787 17.0118C16.9912 16.6993 17.1668 16.2754 17.1668 15.8333V10.8333C17.1668 10.3913 16.9912 9.96738 16.6787 9.65482C16.3661 9.34226 15.9422 9.16667 15.5002 9.16667H5.50016C5.05814 9.16667 4.63421 9.34226 4.32165 9.65482C4.00909 9.96738 3.8335 10.3913 3.8335 10.8333V15.8333C3.8335 16.2754 4.00909 16.6993 4.32165 17.0118C4.63421 17.3244 5.05814 17.5 5.50016 17.5Z",
      stroke: "#492983",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};